<template>
<div class='myPostIndex'>
    <img class="avater1" :src="userStatus.avatarPath" />
    <p class="nickname">
        {{userStatus.nickname}}
    </p>
    <p class="nickname" v-if="userStatus.companyVo">
        {{userStatus.companyVo.company}}({{userStatus.companyVo.companyName}})
    </p>
    <el-button class="bdButton" type="danger" @click="quit">退出登录</el-button>
</div>
</template>

<script>
import axios from 'axios'
import Config from '../config/index'
import {
    setInterval
} from 'timers';
let QRCode = require('qrcode')
export default {
    name: 'my',
    props: {},
    data() {
        return {
            userStatus: this.$store.state.userStatus,
        }
    },
    computed: {
        userStatusfunc() {
            return this.$store.state.userStatus;
        }
    },
    watch: {
        userStatusfunc(val) {
            this.userStatus = val
        },
    },
    created: function () {},
    methods: {
        quit: function () {
            localStorage.clear()
            this.$store.commit('setUser', {})
            this.$router.push({
                name: 'index'
            })
        }
    },
    mounted: function () {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss">
.myPostIndex {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-width: 1920px;
    flex: 1;
    padding-top: 1px;
    position: relative;
    background-color: #e6e6e6;

    .avater1 {
        width: 150px;
        height: 150px;
        border-radius: 100%;
    }

    .nickname {
        color: #5DC2D0;
        margin-top: 20px;
    }

    .bdButton {
        margin-left: 0 !important;
        margin-top: 60px;
    }
}
</style>
